import { createContext } from 'react';

interface Default {
  default: string;
}

//
interface Background extends Default {
  bottomNav: string;
}
interface Color extends Default {
  bottomNavSelect: string;
  bottomNavUnSelect: string;
}
interface BorderColor extends Default {}
interface Change {
  up: string;
  down: string;
  keep: string;
}

// 
interface LightTheme {
  background: Background;
  color: Color;
  borderColor: BorderColor;
  change: Change;
}
interface DarkTheme {
  background: Background;
  color: Color;
  borderColor: BorderColor;
  change: Change;
}


const darkTheme: DarkTheme = {
  background: {
    default: '#fff',
    bottomNav: '#25A69A',
  },
  color: { // fontColor
    default: 'black',
    bottomNavSelect: 'black',
    bottomNavUnSelect: '#efefef'
  },

  borderColor: {
    default: '#eee'
  },
  change: {
    up: '#d60000',
    down: '#0051c7',
    keep: 'black'
  },
}
const lightTheme: LightTheme = {
  background: {
    default: '#202020',
    bottomNav: "#333138",
  },
  color: { // fontColor
    default: '#A6A6A6',
    bottomNavSelect: '#efefef',
    bottomNavUnSelect: '#A6A6A6',
  },

  borderColor: {
    default: '#3F3F3F'
  },
  change: {
    up: '#A22027',
    down: '#0051c7',
    keep: '#505051'
  },
}

export const theme = {
  dark: darkTheme,
  light: lightTheme
};

export default createContext(theme.dark);